export default __webpack_public_path__ + "static/laptop_w.dbd5a69ff814a4786c375ec1137ade51.svg";